var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('filters',{on:{"filtersUpdated":_vm.filtersChangeHandler}})],1)],1),_c('buyer-sales',{attrs:{"filters":_vm.filters}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }